import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import ListItem from 'components/atoms/ListItem';
import VStack from "components/atoms/stack/VStack";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedLayout, { createRefreshControl } from "components/atoms/ThemedLayout";
import ThemedList from "components/atoms/ThemedList";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedModal from "components/atoms/ThemedModal";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import MutationTransaction from "graphql/mutations/MutationTransaction";
import { useMemo, useState } from "react";
import { StyleSheet } from "react-native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import { ThemedValues } from "styles/themed";
import Button from "theme/Button";
import Text from "theme/Text";
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import { openUrl } from "utils/helper-url";
import HelperPrice from "utils/helper/HelperPrice";
import useRouteParameters from "utils/hooks/use-route-parameters";
import useFetch from "utils/hooks/useFetch";
import useMutate from "utils/hooks/useMutate";
import i18n from "utils/i18n";
import _ from "lodash";
import Translate from "utils/translate";
import FetchTransaction from "utils/fetch/FetchTransaction";
import React from "react";
import MutationTransactionPayment from "graphql/mutations/MutationTransactionPayment";
import { AppRoutes } from "navigations/app-routes";
import ReactTimeout from "react-timeout";
import { useTimeout } from "utils/hooks/use-timeout";

const HomeMoreCreditsBundlePaymentScene = () => {

	const navigation = useNavigation();
	const route = useRoute();
	const _routeParameters = useRouteParameters( route );

	const fromBooking = (_routeParameters?.fromBooking === 'true' || _routeParameters?.fromBooking === true ) || false;
	
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const { data, loading, refetch } = useFetch( FetchTransaction.fetch, {
		variables: {
			guid: _routeParameters?.transaction || null,
		}
	});

	const [ createTransactionPayment, { loading: transactionLoading, error: transactionError, data: transactionData } ] = useMutate( MutationTransactionPayment );

	const onPressHome = () => {
		if( fromBooking ) {
			navigation.goBack();
			return
		}

		navigation.dispatch(
			CommonActions.reset({
				index: 0,
				routes: [
					{
						name: AppRoutes.MORE_CREDITS,
					}
				]
			})
		);
	}

	useTimeout(() => {
		if( !loading ) {
			refetch();
		}
	}, 5000);

	const onPressOpenPayment = () => {
		openUrl( data?.payment?.external_redirect_url );
	}

	const onPressCreatePayment = () => {
		createTransactionPayment({
			variables: {
				transaction_guid: data.guid,
			},
			onSuccess: ( result ) => {
				// Open the payment URL!
				openUrl( result?.payment?.external_redirect_url, '_self' )
			},
			onError: ( error ) => {
				console.error('testy5', 'Transaction error', error );
			},
		})
	}

	const content = useMemo( () => {
		const isTransactionCompleted = data?.status === 'completed';

		const isPaymentPending = data?.payment?.status === 'pending';
		const isPaymentFailed = data?.payment?.status === 'canceled';

		if( isPaymentPending ) {
			return (
				<VStack space={ ThemedValues.stackSpace }>
					<Text>{ i18n.t( 'page.credits_buy.payment.pending' ) }</Text>
					<Button
						onPress={ onPressHome }
						loading={ transactionLoading }>

						{ fromBooking ? i18n.t( 'page.credits_buy.payment.button_goback' ) : i18n.t( 'page.credits_buy.payment.button_completed' ) }
					</Button>
				</VStack>
			);
		}

		if( isTransactionCompleted ) {
			return (
				<VStack space={ ThemedValues.stackSpace }>
					<Text>{ i18n.t( 'page.credits_buy.payment.completed' ) }</Text>

					<Button
						onPress={ onPressHome }
						loading={ transactionLoading }>

						{ fromBooking ? i18n.t( 'page.credits_buy.payment.button_goback' ) : i18n.t( 'page.credits_buy.payment.button_completed' ) }
					</Button>
				</VStack>
			);
		}

		if( isPaymentFailed ) {
			return (
				<VStack space={ ThemedValues.stackSpace }>
					<Text>{ i18n.t( 'page.credits_buy.payment.failed' ) }</Text>
					<Button
						onPress={ onPressCreatePayment }
						loading={ transactionLoading }>

						{ i18n.t( 'page.credits_buy.payment.retry_payment' ) }
					</Button>
				</VStack>
			);
		}

		return (
			<VStack space={ ThemedValues.stackSpace }>
				<Text>{ i18n.t( 'page.credits_buy.payment.created' ) }</Text>
				<Button
					onPress={ onPressOpenPayment }
					loading={ transactionLoading }>

					{ i18n.t( 'page.credits_buy.payment.open_payment' ) }
				</Button>
			</VStack>
		);
	}, [ data, transactionLoading, fromBooking ])

	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				showBackButton
				title={ i18n.t( 'titles.credits_buy' ) }
				scrollViewProps={{
					...createRefreshControl({
						// onRefresh: reloadMessages.bind( this )
					})
				}}>
				
				{ !loading && (
					<VStack
						space={ ThemedValues.stackSpace }>

						<ThemedBlock
							mediumPadding
							shadow>

							{ content }
						</ThemedBlock>
					</VStack>
				)}
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	listContainer: {
		flex: 1
	}
})

export default ReactTimeout( HomeMoreCreditsBundlePaymentScene )
